export default {
  state: {
    markers: [],
    markerTypes: [
      { label: 'multi_choice_key', value: 'multiple', typeId: 1 },
    ],
    showModal: false,
    selectedMarkerType: null,
    selectedItemData: null,
    markerDragState: {
      isDragging: false,
      draggedMarkerId: null,
      dragStartTime: null
    }
  },
  
  mutations: {
    SET_MARKERS(state, markers) {
      state.markers = markers
    },
    
    ADD_MARKER(state, marker) {
      marker.isNew = true;
      state.markers.push(marker)
    },
    
    UPDATE_MARKER(state, { markerId, updatedMarker }) {
      const index = state.markers.findIndex(m => m.id === markerId)
      if (index !== -1) {

        Object.keys(updatedMarker).forEach(key => {
          state.markers[index][key] = updatedMarker[key]
        })

      } else {
        console.warn("UPDATE_MARKER - Marker not found:", markerId)
      }
    },
    
    REMOVE_MARKER(state, markerId) {
      const index = state.markers.findIndex(m => m.id === markerId)
      if (index !== -1) {
        state.markers.splice(index, 1)
      }
    },
    
    SET_SHOW_MODAL(state, show) {
      state.showModal = show
    },
    
    SET_SELECTED_MARKER_TYPE(state, markerType) {
      state.selectedMarkerType = markerType
    },
    
    SET_SELECTED_ITEM_DATA(state, itemData) {
      state.selectedItemData = itemData
    },
    
    CLEAR_MARKERS(state) {
      state.markers = []
    },
    
    SET_MARKER_DRAG_START(state, { markerId, startTime }) {
      state.markerDragState = {
        isDragging: true,
        draggedMarkerId: markerId,
        dragStartTime: startTime
      }
    },
    
    SET_MARKER_DRAG_END(state) {
      state.markerDragState = {
        isDragging: false,
        draggedMarkerId: null,
        dragStartTime: null
      }
    }
  },
  
  actions: {
    openModal({ commit, state }, item) {
      const markerType = state.markerTypes.find(t => t.typeId === item.typeId)
      commit('SET_SELECTED_MARKER_TYPE', markerType)
      commit('SET_SELECTED_ITEM_DATA', item)
      commit('SET_SHOW_MODAL', true)
    },
    
    closeModal({ commit }) {
      commit('SET_SHOW_MODAL', false)
      commit('SET_SELECTED_MARKER_TYPE', null)
      commit('SET_SELECTED_ITEM_DATA', null)
    },
    
    addMarker({ commit }, markerData) {
      commit('ADD_MARKER', markerData)
    },
    
    updateMarker({ commit }, { markerId, updatedMarker }) {
      commit('UPDATE_MARKER', { markerId, updatedMarker })
    },
    
    removeMarker({ commit }, markerId) {
      commit('REMOVE_MARKER', markerId)
    },
    
    clearMarkers({ commit }) {
      commit('CLEAR_MARKERS')
    },
    
    setMarkers({ commit }, markers) {
      commit('SET_MARKERS', markers)
    },
    
    startMarkerDrag({ commit }, { markerId, startTime }) {
      commit('SET_MARKER_DRAG_START', { markerId, startTime })
    },
    
    endMarkerDrag({ commit }) {
      commit('SET_MARKER_DRAG_END')
    }
  },
  
  getters: {
    markers: state => state.markers,
    markerTypes: state => state.markerTypes,
    showModal: state => state.showModal,
    selectedMarkerType: state => state.selectedMarkerType,
    selectedItemData: state => state.selectedItemData,
    markerDragState: state => state.markerDragState,
    isMarkerDragging: state => state.markerDragState.isDragging,
    draggedMarkerId: state => state.markerDragState.draggedMarkerId,
    getModalComponent: (state) => (markerType) => {
      if (!markerType) return null
      switch (markerType.typeId) {
        case 1:
          return 'MultiChoiceQuestionModal'
        case 2:
          return 'MultiSectionQuestionModal'
        default:
          return 'MultiChoiceQuestionModal'
      }
    },
    newMarkers: state => state.markers.filter(m => m.isNew)
  }
} 